import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { Product } from 'src/app/order/models/product.model';
import { ProductService } from 'src/app/quoting/services/product.service';

@Component({
    selector: 'app-products-label',
    templateUrl: './products-label.component.html',
    styleUrls: ['./products-label.component.scss'],
    standalone: false
})
export class ProductsLabelComponent implements OnInit {

  product: Product = new Product();

  isServerError: boolean = false;

  constructor(private route: ActivatedRoute,
    private productService: ProductService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadProduct(+params['id']);
    })
  }

  loadProduct(id: number): void {
    this.productService.getProductById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((product: Product) => {
      this.product = product;
    })
  }

  getSku(): string {
    return this.product.sku ? 'SKU: ' + this.product.sku : '';
  }

  print(): void {
    window.print();
  }
}
